/* eslint-disable react/no-array-index-key */
import * as React from "react";
import { PiletApi } from "opencak-app";
import axios from "axios";
import { formulierPageContainerClassName } from "@klantondersteuning-zakelijk/shared";
import { FoldersAanvragenFormulierPage } from "@page/folders-aanvragen";

import "./sass/form-base-component.scss";
import { ContactFormulierPage } from "@page/contact-formulier";

export function setup(app: PiletApi) {
  const basePath = app.getData("base-path");
  const apiUrl = app.getData("api-path");
  const authEnabled = app.getData("api-auth-enabled");
  const Layout = app.getFormPageLayoutComponent();

  const FoldersAanvragenFormulierForm = () => (
    <Layout>
      <div className={`${formulierPageContainerClassName}`}>
        <FoldersAanvragenFormulierPage
          pageBaseUrl={`${basePath}/zakelijk/zelf-regelen/aanvraagformulier-folders`}
          apiUrl={apiUrl}
        />
      </div>
    </Layout>
  );

  const ContactFormulierForm = () => (
    <Layout>
      <div className={`${formulierPageContainerClassName}`}>
        <ContactFormulierPage
          pageBaseUrl={`${basePath}/zakelijk/zelf-regelen/contactformulier`}
          apiUrl={apiUrl}
        />
      </div>
    </Layout>
  );

  axios.defaults.withCredentials = authEnabled;
  app.registerPage(
    `${basePath}/zakelijk/zelf-regelen/aanvraagformulier-folders/:formStep?`,
    FoldersAanvragenFormulierForm
  );
  app.registerPage(`${basePath}/zakelijk/zelf-regelen/contactformulier/:formStep?`, ContactFormulierForm);
}
